import { IconUserCircle } from '@maia/icons';
import { ComponentProps } from 'react';
import { Radio as AriaRadio } from 'react-aria-components';
import { twMerge } from 'tailwind-merge';
import {
  radioIndicator,
  radioIndicatorContainer,
} from '../../../forms/radio/variants';
import { CustomerStatus } from '../../table/cells/CustomerStatus';
import { cardStyles } from '../../../patterns/card';
import { Typography } from '../../../atoms/typography/typography';

type UserRadioCardProps = {
  reference: string;
  name: string;
  address: string;
  tag: ComponentProps<typeof CustomerStatus>;
} & ComponentProps<typeof AriaRadio>;

export function UserRadioCard(props: UserRadioCardProps) {
  const { reference, name, address, tag, ...rest } = props;

  return (
    <AriaRadio
      className={cardStyles({
        variant: 'elevated',
        className:
          'group flex items-center px-20 py-24 gap-x-40 cursor-pointer',
      })}
      {...rest}
    >
      <div className="flex items-center gap-x-12">
        <div className={twMerge(radioIndicatorContainer({ size: 'small' }))}>
          <span className={radioIndicator({ size: 'small' })} />
        </div>

        <Typography variant="body-xs" weight="medium" className="text-info300">
          {reference}
        </Typography>
      </div>
      <div className="flex items-center gap-x-12 min-w-[236px]">
        <IconUserCircle className="fill-primaryMain size-24" />
        <Typography variant="body-xs" weight="medium">
          {name}
        </Typography>
      </div>
      <Typography variant="body-xs" weight="regular" className="grow">
        {address}
      </Typography>
      <CustomerStatus {...tag} />
    </AriaRadio>
  );
}
